export const SURVEY_COMMENT_SUFFIX = '_Comment'
export const SURVEY_FILE_SUFFIX = '_File'
export const SURVEY_FILE_KEY_SUFFIX = '_FileKey'
